import React from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

import moment from "moment";
import { ThailandTripSelect } from "./components/ThailandTripSelect";
import { PackageSelector } from "./components/PackageSelector";
import { SailSquadSelect } from "./components/SailSquadSelect";
import { BaliSelect } from "./components/BaliSelect";
import { SurfSquadSelect } from "./components/SurfSquadSelect";
import { SnowSquadSelect } from "./components/SnowSquad";

export const InfoSection = ({ spotsLeft, trip, getTrip, linkedTrips }) => {
  const [open, setOpen] = React.useState(0);
  const [alwaysOpen, setAlwaysOpen] = React.useState(true);
  const handleAlwaysOpen = () => setAlwaysOpen((cur) => !cur);
  const handleOpen = (value) => setOpen(open === value ? 0 : value);
  const currentDate = new Date();

  // Format the date to a readable string, for instance "Friday, October 13, 2023"
  const formattedDate = currentDate.toLocaleDateString(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const formattedTime = currentDate.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <>
      <section
        className="py-6 px-4 bg-white shadow-2xl p-4"
        style={{ borderRadius: 20, margin: 20 }}
      >
        <h2 className="text-2xl font-bold text-center mb-2">{trip.name}</h2>
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Go{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={trip.canvaLink}
            className="text-blue-500 mt-8"
          >
            here
          </a>{" "}
          for more trip information.
        </div>

        <h4 style={{ marginTop: 8 }}>When</h4>
        {trip.name.includes("Thailand") ? (
          <>
            {/* <ThailandTripSelect current={trip.slug} />
            <div style={{ fontSize: 12 }}>
              Changing dates will restart your registration process
            </div> */}
          </>
        ) : (
          <>
          {false ? (
            <>
              {/* <SnowSquadSelect current={trip.slug} />
              <div style={{ fontSize: 12 }}>
                Changing dates will restart your registration process
              </div> */}
            </>
          ) : (
            <>
              {trip.name.includes("Sail Squad") && !trip.name.includes("Premium") && trip.location === 'Greece' ? (
                <>
                <SailSquadSelect current={trip.slug} />
                <div style={{ fontSize: 12 }}>
                  Changing dates will restart your registration process
                </div>
              </>
            ) : (
              <>
                {trip.name.includes("Bali Villa") ? (
                  <>
                    <BaliSelect current={trip.slug} />
                    <div style={{ fontSize: 12 }}>
                      Changing dates will restart your registration process
                    </div>
                  </>
                ) : (
                  <>
                    {trip.name.includes("Surf Squad Portugal 2025") ? (
                      <>
                        <SurfSquadSelect current={trip.slug} />
                        <div style={{ fontSize: 12 }}>
                          Changing dates will restart your registration process
                        </div>
                      </>
                    ) : (
                      <>
                        <strong>
                          {moment.utc(trip.start).format("MMM Do") +
                            " - " +
                            moment.utc(trip.end).format("MMM Do, YYYY")}
                        </strong>
                        <br />
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
        </>
        )}

        <PackageSelector
          trip={trip}
          getTrip={getTrip}
          linkedTrips={linkedTrips}
        />

        <h4 style={{ marginTop: 8 }}>Where</h4>
        <strong>{trip.location}</strong>
        <h4 style={{ marginTop: 8 }}>Packages Remaining</h4>
        <strong>{`${spotsLeft < 1 ? "Sold Out" : spotsLeft}`}</strong>
        {spotsLeft < 1 && linkedTrips ? (
          <div style={{ fontSize: 12 }}>
            Please select a different package from the dropdown.
          </div>
        ) : (
          <></>
        )}

        <div style={{ fontSize: 12 }}>
          as of {formattedDate} {formattedTime}
        </div>
        <h4 style={{ marginTop: 8 }}>Full Payment Price</h4>
        <h2>
          <strong>£{trip.price / 100}</strong>{" "}
          {trip.damageDepositAmount > 0
            ? `(plus a £${
                trip.damageDepositAmount / 100
              } refundable damage deposit)`
            : ""}
        </h2>
        {/* {trip && trip.paymentPlan && trip.paymentPlan.length > 0 ? (
          <>
            <h4 style={{ marginTop: 8 }}>Payment Plan Price (10% fee)</h4>
            <h2>
              <strong>
                £{
                  (
                    (trip.depositAmount || 0) +
                    trip.paymentPlan
                      .filter(
                        (item) =>
                          !(
                            typeof item.description === "string" &&
                            item.description.toLowerCase().includes("deposit")
                          )
                      )
                      .reduce((sum, item) => sum + (item.amount || 0), 0)
                  ) / 100
                }
              </strong>{" "}
              {trip.damageDepositAmount > 0
            ? `(plus a £${
                trip.damageDepositAmount / 100
              } refundable damage deposit)`
            : ""}
            </h2>
          </>
        ) : (
          <></>
        )} */}
        <div style={{ fontSize: 12 }}>
          We accept payment in USD, GBP, EUR and many other currencies on the
          checkout page
        </div>
        <Accordion open={alwaysOpen}>
          <AccordionHeader onClick={handleAlwaysOpen}>
            Payment Details
          </AccordionHeader>
          <AccordionBody>
            When registering, you can pay in full or pay a non-refundable
            deposit of £{trip.depositAmount / 100}. If you pay the deposit, the
            remaining payments will be drafted as described on the checkout page
            (see canva doc for more information on this).
          </AccordionBody>
        </Accordion>

        <br />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.thetravelsquad.com/terms-of-use"
          className="text-blue-500"
        >
          Terms of Use
        </a>
        <br />
        {trip.nucoPackageId ? (
          <>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.nucotravel.com/en-gb/terms-and-conditions/travelsquad2023?internal-traffic=true"
              className="text-blue-500"
            >
              Booking Terms & Conditions
            </a>
            <br />
          </>
        ) : (
          <></>
        )}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.thetravelsquad.com/privacy-policy"
          className="text-blue-500"
        >
          Privacy Policy
        </a>

        {/*<Accordion open={open === 1}>*/}
        {/*  <AccordionHeader onClick={() => handleOpen(1)}>*/}
        {/*    FAQ 2*/}
        {/*  </AccordionHeader>*/}
        {/*  <AccordionBody>*/}
        {/*    Can open on click*/}
        {/*  </AccordionBody>*/}
        {/*</Accordion>*/}
        {/*<Accordion open={open === 2}>*/}
        {/*  <AccordionHeader onClick={() => handleOpen(2)}>*/}
        {/*    FAQ 3*/}
        {/*  </AccordionHeader>*/}
        {/*  <AccordionBody>*/}
        {/*    Can open on click*/}
        {/*  </AccordionBody>*/}
        {/*</Accordion>*/}
      </section>
    </>
  );
};
